/* eslint-disable import/no-anonymous-default-export */
export default {
  methods: {
    async resendEmailAccess(email, token, recaptcha) {
      const url = this.$store.state.global.baseUrl;
      const payload = { email, token, recaptcha };
      return await this.$http.post(
        `${url}/api/account/sendemailfirstlogin`,
        payload,
        { validateStatus: _ => true }
      );
    },
    async setPassword(
      password,
      confirmPassword,
      token,
      recaptcha,
    ) {
      const url = this.$store.state.global.baseUrl;
      const payload = {
        password,
        confirmPassword,
        passwordToken: token,
        recaptcha,
      };
      return await this.$http.post(`${url}/api/account/resetpassword`, payload, {
        validateStatus: _ => true
      });
    }
  }
};
